import { createContext, type ReactNode, useContext } from 'react';
import enGB from '@/ui-kit/localization/locales/enGB';
import fiFI from '@/ui-kit/localization/locales/fiFI';
import svSE from '@/ui-kit/localization/locales/svSE';
import type { Translation } from '@/ui-kit/localization/locales/types';

type State = {
  translation: Translation;
};

const Context = createContext<State | undefined>(undefined);

type Locale = 'sv-SE' | 'en-GB' | 'fi-FI';

const LocaleMap: Record<Locale, Translation> = {
  'sv-SE': svSE,
  'en-GB': enGB,
  'fi-FI': fiFI,
};

type Props = {
  locale: Locale;
  children: ReactNode;
};

export const UiKitLocalizationContext = ({ locale, children }: Props) => (
  <Context value={{ translation: LocaleMap[locale] }}>{children}</Context>
);

export const useUiKitTranslation = () => {
  const context = useContext(Context);

  if (!context) {
    throw new Error('useUiKitTranslation must be used within a UiKitLocalizationContext');
  }

  return context.translation;
};
